import { ModalOverlayStyleConfig } from '../types';

export const styleConfig: ModalOverlayStyleConfig = {
  baseStyle: {
    bg: 'white',
  },
  variants: {
    transparent: () => ({
      bg: 'transparent',
    }),
    'semi-transparent': () => ({
      bg: 'black',
      opacity: '0.25 !important',
    }),
    light: () => ({
      bg: 'white',
      opacity: '1',
    }),
    dark: () => ({
      bg: 'black',
      opacity: '1',
    }),
  },
  defaultProps: {
    variant: 'semi-transparent',
  },
};
